<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="grey lighten-5" :hide-actions="hideActions" :class="{'pr-11': hideActions}">
      <div class="row">
        <div class="col-6 d-flex align-center">
          <span :class="{'red--text': invalid}"><b>{{ label }} </b></span>
        </div>
        <div class="col-6 d-flex">
          <div class="mt-3 mr-1">Вес:</div>
          <div>
            <v-text-field outlined dense class="weight-input" :value="value" @input="updateValue" :error-messages="errorMessages" @click.stop="test()"
            />
          </div>
        </div>
      </div>
    </v-expansion-panel-header>
    <slot>
    </slot>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    errorMessages: Array,
    vuelidate: Object,
    invalid: Boolean,
    hideActions: Boolean
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event);
      if (this.vuelidate) {
        this.vuelidate.$model = event;
        this.vuelidate.$touch();
      }
    },
    test() {
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.weight-input .v-input__control {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.weight-input .v-input__slot {
  width: 80px;
  flex: 0 0 auto;
}

.profgram-dialog .rank-edit {
  width: 80px;
}

</style>
